<template>
  <div :class="['relative', isNotAllowedSelect ? 'cursor-not-allowed' : 'cursor-pointer']">
    <TestAddedCover v-if="belongToDisabledXChooseYPanel" />
    <div 
      :class="[
        { 'not-allowed-select': isNotAllowedSelect },
        classList[classIndex]
      ]"
      :style="classIndex === 0 && testNode.descendants.length === 0 ? 'line-height: 24px;' : 'line-height: 18.2px;'"
      @click.stop="handleClickTest(testNode.value)"
    >
      <PromoTestCardWithCheckbox 
        :test-node="testNode"
        :select-prop="selectProp"
        :is-not-allowed-select="isNotAllowedSelect"
        :show-age-restriction="!isAllowedForPatientAge"
        :selected-vw-test-price="selectedVwTestPrice"
        :show-checkbox="testNode.id !== 828"
        :show-price="testNode.id !== 828"
      />
    </div>
    <PromoTestTreeNode
      v-for="descendant in testNode.descendants"
      :key="descendant.id"
      :test-node="descendant"
      :class-index="classIndex + 1"
      :remaining-quantity="remainingQuantity"
      :select-prop="selectProp"
      :is-not-allowed-select-prop="isNotAllowedSelectProp"
      :order-test-support-obj="orderTestSupportObj"
      :selected-vw-test-price="selectedVwTestPrice"
      :disabled-x-choose-y-panel-test-ids="disabledXChooseYPanelTestIds"
    />  
  </div> 
</template>

<script>
import { isItemAllowedForPatientAge } from "../../custom-panel/customPanelCard";
import PromoTestCardWithCheckbox from "./PromoTestCardWithCheckbox.vue";
import { addSelectedTest, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
import TestAddedCover from "./TestAddedCover.vue";
import { mapGetters } from "vuex";
export default {
  name: "PromoTestTreeNode",
  components: {
    PromoTestCardWithCheckbox,
    TestAddedCover
  },
  props: {
    testNode: {
      type: Object,
      default: () => {}
    },
    classIndex: {
      type: Number,
      default: 0
    },
    remainingQuantity: {
      type: Number,
      default: 0
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    },
    selectedVwTestPrice: {
      type: Number,
      default: 0
    },
    disabledXChooseYPanelTestIds: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      // different design for each layer of tests in va or vw trees
      classList: ["layer-1", "layer-2"]
    }
  },

  computed: {
    ...mapGetters("orderTest/order", ["patientAge"]),
    isAllowedForPatientAge() {
      return isItemAllowedForPatientAge(this.testNode.value, this.orderTestSupportObj, this.patientAge);
    },
    isNotAllowedSelect() {
      return this.testNode.value[this.isNotAllowedSelectProp] 
        || !this.isAllowedForPatientAge 
        || (!this.testNode.value[this.selectProp] && this.remainingQuantity === 0);
    },
    belongToDisabledXChooseYPanel() {
      return this.disabledXChooseYPanelTestIds.includes(this.testNode.id) ? true : false;
    }
  },

  methods: {
    // select or de-select test
    handleClickTest(test) {
      test[this.selectProp] 
        ? removeSelectedTest(test.id, this.selectProp, this.orderTestSupportObj)
        : addSelectedTest(test.id, this.selectProp, this.orderTestSupportObj);
      console.log({...this.orderTestSupportObj})
    },
  }
}
</script>

<style scoped>
.not-allowed-select {
  pointer-events: none;
  background-color: #E6E6E6;
  color: #979797;
}

.layer-1 {
  /* font-family: IBM Plex Sans Hebrew; */
  font-size: 14px;
  font-weight: 500;
}

.layer-2 {
  /* font-family: IBM Plex Sans Hebrew; */
  font-size: 14px;
  font-weight: 400;
  line-height: 18.2px;
  padding-left: 13px;
  margin-top: 4px;
}
</style>